export type ReferenceHighlightFeedbackState = {
  isCurrent: boolean;
  shouldFetch: boolean;
  isContextMode: boolean;
  highlightsEnabled: boolean;
  isLoaded: boolean;
  matchCount: number | undefined;
};

export const shouldShowNoMatchFeedback = ({
  isCurrent,
  shouldFetch,
  isContextMode,
  highlightsEnabled,
  isLoaded,
  matchCount,
}: ReferenceHighlightFeedbackState): boolean =>
  isCurrent &&
  shouldFetch &&
  isContextMode &&
  highlightsEnabled &&
  isLoaded &&
  matchCount === 0;

export const getNoMatchAnalyticsProperties = (
  pageId: string,
  sectionId: string,
  queryLength: number
) => ({
  pageId,
  sectionId: sectionId || null,
  queryLength,
  matchCount: 0,
});
